export default __webpack_public_path__ + "static/russian-1-e11edb7e55bb8a0dafd3d03b9e17926a.jpg";